import { IMAGE, MULTI_SELECT, SELECT, TEXT, COLOR_PICKER, COUNTER, SWITCH } from "../../components/Common/Const";

export const TeamFields = [
    {
        type: SELECT,
        name: "eventTypeId",
        label: "Event Type",
        parentclassName: "",
        isRequired: true,
        requiredErrorMessage: "Please enter event type.",
        options: [{ label: "Select Event Type", value: "0" }],
        defaultValue: "0",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 }
    },
    {
        type: TEXT,
        name: "teamName",
        label: "Team Name",
        parentclassName: "",
        isRequired: true,
        regex: /^.{0,100}$/,
        regexErrorMessage: "Max allowed Characters 100",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        requiredErrorMessage: "Please enter team name.",
    },
    {
        type: TEXT,
        name: "teamShortName",
        label: "Short Name",
        parentclassName: "",
        isRequired: true,
        regex: /^.{0,100}$/,
        regexErrorMessage: "Max allowed Characters 100",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        requiredErrorMessage: "Please enter short name.",
    },
    {
        type: SELECT,
        name: "countryId",
        label: "Country",
        parentclassName: "",
        options: [],
        // regex: /^[^']{1,100}$/,
        // regexErrorMessage: "Max allowed Characters 100, No Spacial(') Character",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
    {
        type: IMAGE,
        name: "jersey",
        label: "Jersey Image",
        parentclassName: "",
        isValidateImage: true,
        validateWidth:664,
        validateHeight:254
    },
    {
        type: IMAGE,
        name: "image",
        label: "Team Image",
        parentclassName: "",
        isValidateImage: true,        
        validateWidth:400,
        validateHeight:400    
    },
    {
        type: SWITCH,
        name: "isMen",
        label: "Is Men",
        defaultValue: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 }
    },
    {
        type: SWITCH,
        name: "isInternational",
        label: "Is International",
        defaultValue: false,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 }
    },
    {
        type: MULTI_SELECT,
        name: "playerId",
        label: "Select Players",
        options: [],
        showSelectAll: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
    {
        type: COLOR_PICKER,
        name: "teamColor",
        label: "Team Color",
        parentclassName: "",
    },
    {
        type: COLOR_PICKER,
        name: "backgroundColor",
        label: "Background Color",
        parentclassName: "",
    },
    {
        name: "tpId",
        label: "TPID",
        type: COUNTER,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
    },
]